import React, { useMemo, useState } from 'react';

import { IBackendCartEntries } from '@rbi-ctg/menu';
import Currency from 'components/currency';
import { useComposeDescription } from 'hooks/use-compose-description';
import { t } from 'state/intl/translations';
import { CartEntryType } from 'utils/cart/types';

import {
  DescriptionRow,
  Divider,
  StyledLinkButton,
  Total,
  TotalLabelTitle,
  TotalsRow,
} from './modal-order-details.styled';

const ITEMS_DISPLAY_LENGTH = 2;

export const OrderItem = ({ cartEntry }: { cartEntry: IBackendCartEntries }) => {
  const { name, price, quantity } = cartEntry;
  const isOfferDiscount = cartEntry.type === CartEntryType.offerDiscount;
  const shouldShowPrice = price !== null && !isOfferDiscount;

  const [showAllModifiers, setShowAllModifiers] = useState(false);

  const cartEntryDescriptions = useComposeDescription(cartEntry, {
    includeModifiers: true,
    includeQuantity: true,
  });

  const modifiers = useMemo(() => {
    return cartEntryDescriptions?.slice(
      0,
      !showAllModifiers ? ITEMS_DISPLAY_LENGTH : cartEntryDescriptions.length
    );
  }, [cartEntryDescriptions, showAllModifiers]);

  const toggleModifiersList = () => {
    setShowAllModifiers(prevState => !prevState);
  };

  const toggleTextKey = showAllModifiers ? 'showLess' : 'showMore';
  const toggleText = t(toggleTextKey);

  return (
    <>
      <TotalsRow>
        <TotalLabelTitle>{name}</TotalLabelTitle>
        {shouldShowPrice && (
          <Total>
            <Currency amount={price} />
          </Total>
        )}
      </TotalsRow>

      <DescriptionRow mb="$3">
        {t('qty')}
        {quantity}
      </DescriptionRow>

      {modifiers?.map((descriptionItem, index) => (
        <DescriptionRow key={`descriptionItem-${index}`}>{descriptionItem}</DescriptionRow>
      ))}

      {cartEntryDescriptions.length > ITEMS_DISPLAY_LENGTH && (
        <StyledLinkButton onPress={toggleModifiersList}>{toggleText}</StyledLinkButton>
      )}

      <Divider />
    </>
  );
};
